var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1954_1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42862 3.17853H2.67862C2.11031 3.17853 1.56526 3.40429 1.1634 3.80616C0.761532 4.20802 0.535767 4.75307 0.535767 5.32139V12.8214C0.535767 13.3897 0.761532 13.9347 1.1634 14.3366C1.56526 14.7385 2.11031 14.9642 2.67862 14.9642H10.1786C10.7469 14.9642 11.2919 14.7385 11.6938 14.3366C12.0957 13.9347 12.3215 13.3897 12.3215 12.8214V9.07139",
    stroke: "#EFFEF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7857 6.39291C13.2651 6.39291 14.4643 5.19367 14.4643 3.71434C14.4643 2.23501 13.2651 1.03577 11.7857 1.03577C10.3064 1.03577 9.10718 2.23501 9.10718 3.71434C9.10718 5.19367 10.3064 6.39291 11.7857 6.39291Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1954_1714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notification-active.46a75e3f83c7b5084795cafaa7dd6c4f.svg";
export { ForwardRef as ReactComponent };